import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pallet",
  "use": "icon-pallet-usage",
  "viewBox": "0 0 1280 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1280 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pallet\"><path d=\"M288 512h704c17.6 0 32-14.4 32-32V32c0-17.6-14.4-32-32-32H768v256l-128-64-128 64V0H288c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32z m960 256c17.6 0 32-14.4 32-32v-64c0-17.6-14.4-32-32-32H32c-17.6 0-32 14.4-32 32v64c0 17.6 14.4 32 32 32h96v128H32c-17.6 0-32 14.4-32 32v64c0 17.6 14.4 32 32 32h1216c17.6 0 32-14.4 32-32v-64c0-17.6-14.4-32-32-32h-96v-128h96z m-672 128H256v-128h320v128z m448 0H704v-128h320v128z\" fill=\"#ffffff\" p-id=\"3593\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pallet.svg
// module id = HWYI
// module chunks = 213